import { Box, Tabs, Tab, Divider } from '@mui/material'
import { useState } from 'react'
import Sound from './Sound'
import LineOA from './LineOA'
import Email from './Email'
import Volumnn from '../../components/icons/Voulumn'
import { Container } from '../../components/StyleComponent'
export default function Notifications({ update, create, remove }) {
    const [tab, setTab] = useState(0)

    const renderTabComponent = () => {
        switch (tab) {
            case 0:
                return <Sound update={update} create={create} remove={remove} />
            case 1:
                return <LineOA update={update} />
            case 2:
                return <Email update={update} />
            default:
                return null
        }
    }

    return (
        <Container header={header}>
            <Box sx={{ p: '20px 20px 0px 20px' }}>
                <Tabs value={tab} onChange={(_, nv) => setTab(nv)}>
                    <Tab label='Sound' value={0} />
                    <Tab label='Line OA' value={1} />
                    <Tab label='Email' value={2} />
                </Tabs>
                <Divider />
            </Box>
            <Box sx={{ p: 0 }}>{renderTabComponent()}</Box>
        </Container>
    )
}
const header = {
    icon: <Volumnn />,
    color: 'grey',
    title: 'Notifications',
}
